/* src/app/news/news.component.css */
.link {
  color: #337ab7;
  font-size: 30px;
  display: inline-block;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.btn-default {
  margin-left: 10px;
  margin-bottom: 12px;
}
/*# sourceMappingURL=news.component.css.map */
